import React from 'react'
import { IconFileImport } from '@tabler/icons-react';

const ActionBarMasterStandardsComp = (props) => {
    return (
        <>
            <div className="d-flex align-items-center py-1">
                {/*begin::Button*/}
                <a onClick={() => props.showFormImport()} className="btn btn-sm btn-primary"><IconFileImport stroke={2} /> Import File</a>
                {/*end::Button*/}
            </div>
        </>
    )
}

export default ActionBarMasterStandardsComp
